module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'c-etiquette__texts__container flex-column  flex-fill\'>\r\n    <span class="c-etiquette__text" data-value="'+
((__t=(values))==null?'':__t)+
'">'+
((__t=(text))==null?'':__t)+
'</span>\r\n    <span class=\'c-etiquette__subText cw-texteTresAllege\'>'+
((__t=(subText))==null?'':__t)+
'</span>\r\n</div>\r\n<div class=\'c-etiquette__withIcon_icon\'>\r\n    <!-- icon was here -->\r\n</div>';
}
return __p;
};
